import { Router } from 'express';
import { RoleController } from '../controllers/role.controller';
import { Routes } from '../../../interface/routes.interface';
import { permissionInjector } from '../../../middlewares/permissionInjector';

/**
 * @swagger
 * tags:
 *   name: Role
 *   description: Role Management APIs
 */

export class RoleRoute implements Routes {
    public router = Router();
    public roleController = new RoleController();
    public path = '/role';

    constructor() {
        this.initializeRoutes();
    }

    public initializeRoutes() {
        /**
         * @swagger
         * /role:
         *   post:
         *     summary: Create a new role
         *     tags: [Role]
         *     security:
         *       - bearerAuth: []
         *     requestBody:
         *       required: true
         *       content:
         *         application/json:
         *           schema:
         *             type: object
         *             properties:
         *               name:
         *                 type: string
         *               description:
         *                 type: string
         *     responses:
         *       201:
         *         description: Role created successfully
         */
        this.router.post(`${this.path}`, permissionInjector(`${this.path}`, 'POST'), this.roleController.create);

        /**
         * @swagger
         * /role:
         *   get:
         *     summary: Get all roles
         *     tags: [Role]
         *     security:
         *       - bearerAuth: []
         *     parameters:
         *       - in: query
         *         name: page
         *         schema:
         *           type: integer
         *       - in: query
         *         name: limit
         *         schema:
         *           type: integer
         *       - in: query
         *         name: search
         *         schema:
         *           type: string
         *       - in: query
         *         name: sortBy
         *         schema:
         *           type: string
         *       - in: query
         *         name: sortOrder
         *         schema:
         *           type: string
         *     responses:
         *       200:
         *         description: List of roles
         */
        this.router.get(`${this.path}`, permissionInjector(this.path, 'GET'), this.roleController.getAllRoles);

        /**
         * @swagger
         * /role/{id}:
         *   get:
         *     summary: Get role by ID
         *     tags: [Role]
         *     security:
         *       - bearerAuth: []
         *     parameters:
         *       - in: path
         *         name: id
         *         required: true
         *         schema:
         *           type: string
         *     responses:
         *       200:
         *         description: Role found
         *       404:
         *         description: Role not found
         */
        this.router.get(`${this.path}/:id`, permissionInjector(`${this.path}`, 'GET'), this.roleController.getById);

        /**
         * @swagger
         * /role/{id}:
         *   put:
         *     summary: Update a role
         *     tags: [Role]
         *     security:
         *       - bearerAuth: []
         *     parameters:
         *       - in: path
         *         name: id
         *         required: true
         *         schema:
         *           type: string
         *     requestBody:
         *       required: true
         *       content:
         *         application/json:
         *           schema:
         *             type: object
         *             properties:
         *               name:
         *                 type: string
         *               description:
         *                 type: string
         *     responses:
         *       200:
         *         description: Role updated
         *       404:
         *         description: Role not found
         */
        this.router.put(`${this.path}/:id`, permissionInjector(`${this.path}`, 'PUT'), this.roleController.updateRole);

        /**
         * @swagger
         * /role/{id}:
         *   delete:
         *     summary: Delete a role
         *     tags: [Role]
         *     security:
         *       - bearerAuth: []
         *     parameters:
         *       - in: path
         *         name: id
         *         required: true
         *         schema:
         *           type: string
         *     responses:
         *       200:
         *         description: Role deleted
         *       404:
         *         description: Role not found
         */
        this.router.delete(`${this.path}/:id`, permissionInjector(`${this.path}`, 'DELETE'), this.roleController.deleteRole);
    }
}
